import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppModule} from './app.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
    imports: [
        AppModule,
        BrowserAnimationsModule
    ],
    providers: [],
    bootstrap: [AppComponent],
})
export class AppBrowserModule {
    constructor() {
        console.log('app browser');
    }
}
